import { MaterialUICore, tokens } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.background.default,
    padding: tokens.spacing.sm,
  },
  title: {
    cursor: 'pointer',
    maxWidth: '360px',
  },
  input: {
    '& .MuiFilledInput-input': {
      padding: '10px 8px 8px',
    },
  },
  iputTextArea: {
    width: '100%',
    '& .MuiInputBase-root': {
      height: 'initial',
    },
    '& .MuiFilledInput-inputMultiline': {
      padding: '0 !important',
      height: '144px !important',
    },
    color: theme.palette.text.primary,
  },
  helpText: {
    fontWeight: 500,
    fontSize: tokens.font.size.xxxs,
    color: tokens.color.neutral[700],
    lineHeight: tokens.line.height.sm,
  },
}));

export default useStyles;
